import validate from 'validate.js';

(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('after')) {
            return;
        }
        Object.defineProperty(item, 'after', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function after() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.parentNode.insertBefore(docFrag, this.nextSibling);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

class Validator {
    /**
     * @see https://validatejs.org/
     * @param {String} type - The type to validate the value against
     * @param {String|null} [value=null] -
     * @param {Object} [options]
     */
    constructor(type = null, value = null, options = {}) {
        const { element, errorElement } = options;
        this.errors = [];
        this.val = value;
        this.type = type;
        this.el = element ? element : null;
        this.errEl = errorElement ? errorElement : null;

        Logger.info("Validator", type, value, options);

        // Learning Locker doesn't allow all the characters that pass the email validation.
        // Extra checks are needed to ensure the emails will work on LL
        const badEmailCharacters = '!$^&*=#}{/\|?~'

        const constraints = {
            email: {
                presence: {
                    allowEmpty: false,
                    message: LanguageManager.getString('validation_email_required'),
                },
                email: {
                    message: LanguageManager.getString('validation_email_format'),
                },
                format: {
                    pattern: `^((?![${badEmailCharacters}]).)*$`,
                    message: `Emails contains invalid characters`
                }
            },
            firstName: {
                presence: {
                    allowEmpty: false,
                    message: LanguageManager.getString('validation_first_name_required'),
                },
            },
            lastName: {
                presence: {
                    allowEmpty: false,
                    message: LanguageManager.getString('validation_last_name_required'),
                },
            },
            agreeTerms: {
                presence: {
                    allowEmpty: false,
                    message: LanguageManager.getString('validation_agree_terms_required'),
                },
            },
            agreeDataShareUnion: {
                presence: {
                    allowEmpty: true,
                    message: LanguageManager.getString('validation_agree_data_share_required'),
                },
            },
        };

        this.constraint = constraints[this.type] ? constraints[this.type] : options.constraint;

        if (this.el && this.val === null) {
            this.val = this.el.value;
        }
        if (!this.errEl) {
            const newErrorElement = document.createElement('div');
            newErrorElement.classList.add('errors', 'text-danger');
            this.el.after(newErrorElement);
            this.errEl = newErrorElement;
            this.errEl.style.display = 'none';
        }
        if (this.el) {
            this.el.validation = this;
        }
    }

    setConstraint(constraint) {
        this.constraint = constraint;
    }

    supportsValidation(type) {
        return Object.keys(this.constraints).includes(type);
    }

    valid() {
        return this.errors.length === 0;
    }

    invalid() {
        return !this.valid();
    }

    errors() {
        return this.errors;
    }

    value(value) {
        this.val = value;
    }

    element(element) {
        this.el = element;
    }

    errorElement(element) {
        this.errEl = element;
    }

    validate() {
        if (!this.constraint) {
            throw new Error(`Validator is missing it's constraint`);
        }

        this.clearHints();
        const validation = validate.single(
            this.val,
            this.constraint
        );
        this.errors = validation ? validation : [];

        // debugger;
        Logger.info('VALIDATING', {
            value: this.val,
            type: this.type,
            response: validation,
            valid: this.valid(),
            invalid: this.invalid,
            errors: this.errors,
        });
        if (this.el) {
            this.el.classList.toggle('alert-danger', this.invalid());
            this.el.classList.toggle('alert-success', this.valid());
        }
        if (this.errEl && this.invalid()) {
            this.errEl.style.display = 'block';
            this.errEl.innerHTML = this.errors.join('<br/>');
        }
        if (this.errEl && this.valid()) {
            this.errEl.style.display = 'none';
        }
    }

    clearHints() {
        if (this.el) {
            this.el.classList.toggle('alert-danger', false);
            this.el.classList.toggle('alert-success', false);
        }
        if (this.errEl) {
            this.errEl.innerHTML = '';
        }
    }
}

export default Validator;